const APIOrganizationRequest = {};

// GET Requests

//bee-boy
APIOrganizationRequest["getAllOrganizationsBySiteId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/organizations/site/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getFarmerOrgById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/organizations/farmer-registration/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getOrganizationById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/organizations/registration-form/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getAllARBOTypes"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/arb-organization-type', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getAllARBOServices"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/arb-organization-service', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getAllFundSources"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/fund-source', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getAllDeliverySchemes"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/credit-mf-delivery-scheme', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getAllLoanTypes"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/loan-type', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getAllLoanStatuses"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/loan-status', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getAllFinancialMechanisms"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/financial-mechanism-type', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getAllInfraSupports"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/small-infra-support-type', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getCategoryById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/arbo-category/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getAllARBOCAtegories"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/arbo-category', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getClusterMemberhsipByArboId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/organizations/arbo-and-cluster-membership/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getFinanceByArboId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/organizations/finance/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getAECommitteeByArboId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/organizations/ae-committee/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getAllLoanTypes"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/loan-type', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getAllLoanStatuses"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/loan-status', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getAllFinancialMechanisms"] = async (accessToken) => {
	try {
		const response = await fetch('/api/lib/financial-mechanism-type', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getSISProvidedByARBOId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/organizations/sis-provided/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getSISUsageByARBOId"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/organizations/sis-usage/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getSISProvidedById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/lib/small-infra-support-type/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["getFinanceTrackingById"] = async (accessToken, id) => {
	try {
		const response = await fetch('/api/organizations/financing-tracking/' + id, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

// POST Requests

APIOrganizationRequest["addOrganization"] = async (accessToken, data) => {
	try {
		const response = await fetch('/api/organizations/registration-form', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

// PUT Requests

APIOrganizationRequest["addClusterMembershipByArboId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/organizations/arbo-and-cluster-membership/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["addFinanceByArboId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/organizations/finance/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["addAECommitteeByArboId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/organizations/ae-committee/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["addSISProvidedByOrgId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/organizations/sis-provided/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["addSISUsageByOrgId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/organizations/sis-usage/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["addFinanceTracking"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/organizations/financing-tracking/' + id, {
			method: 'PUT',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

// PATCH Requests

APIOrganizationRequest["editOrganization"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/organizations/registration-form/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["editClusterMembershipByArboId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/organizations/arbo-and-cluster-membership/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["editFinanceByArboId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/organizations/finance/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["editAECommitteeByArboId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/organizations/ae-committee/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["editSISProvidedByOrgId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/organizations/sis-provided/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["editSISUsageByOrgId"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/organizations/sis-usage/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIOrganizationRequest["editFinanceTracking"] = async (accessToken, data, id) => {
	try {
		const response = await fetch('/api/organizations/financing-tracking/' + id, {
			method: 'PATCH',
			headers: {
				'Content-Type': 'application/json',
				'Authorization': "Bearer " + accessToken
			},
			body: JSON.stringify(data)
		});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

export default APIOrganizationRequest
